'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M0 64v896h1024v-896h-1024zM192 896h-128v-128h128v128zM192 704h-128v-128h128v128zM192 448h-128v-128h128v128zM192 256h-128v-128h128v128zM768 896h-512v-320h512v320zM768 448h-512v-320h512v320zM960 896h-128v-128h128v128zM960 704h-128v-128h128v128zM960 448h-128v-128h128v128zM960 256h-128v-128h128v128z' })
    ));
};